module.exports = {"pageTitleText":" Ninja Handler Setting","createText":"Create","hostname":"HostName","groupName":"GroupName","internalIP":"InternalIP","externalIP":"ExternalIP","isEnableProxyProtocol":"Proxy Protocol","serviceIP":"ServiceIP","serviceProvideType":"ServiceProvideType","health":"Health","isenabled":"IsEnabled","connectState":"ConnectState","gitSitesSuccess":"SyncConfig","ninjaIsRunning":"Ninja","errMsg":"Error Message","status":"Status","removeFromGroup":"Remove","removeFromGroupText":"Sure want to remove Ninja Handler?"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en-US/ninjasetting.json
// module id = F9ub
// module chunks = 3